import React, { useEffect, useState } from 'react';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';
import { connect } from 'react-redux';

import Card from './Card';
import CardSkeleton from './CardSkeleton';

import "./style.css"

const ThumbnailWorkoutList = (props) => {
    const { viewedWorkout = null, content, favorite = false, orientation = "x", screenSize, withDate = true, program, level, limit = 1000000 } = props;
    const { allWorkoutHistory, selectedPrograms } = props.User;

    const [phKeys, setPHKeys] = useState([]);
    const [history, setHistory] = useState([]);

    useEffect(() => {
        if (selectedPrograms?.length > 0 && program && level != null) {
            let hist = selectedPrograms.filter(sp => sp.program_id == program && sp.level == level);

            setHistory(hist);
        }

    }, [selectedPrograms, program, level]);

    useEffect(() => {
        if (allWorkoutHistory?.length > 0) {
            let ids = {}

            allWorkoutHistory.map((wh) => {
                if (wh.program == program && wh.level == level && new Date(wh.created_at) >= new Date(history[0]?.created_at)) {
                    ids["w-" + wh.workout_id] = wh;
                }
            })

            setPHKeys(ids);
        }

    }, [allWorkoutHistory?.length, history])

    const slides = {
        s: 1.1,
        s2: 1.1,
        m: 1.9,
        l: 3,
        xl: 5,
    }

    let filtered = content ? content.filter((w, i) => i < limit) : [];

    return (
        <div id="thumbnail-workout-list" className='t-4'>

            {
                orientation == "x" &&
                <Swiper
                    slidesPerView={slides[screenSize]}
                    spaceBetween={0}
                    freeMode={true}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[FreeMode]}
                    className="mySwiper"
                    onReachEnd={() => { }}
                >
                    {
                        filtered && filtered?.length > 0
                            ? filtered && filtered?.map((item, index) => {

                                let vid = {
                                    ...item,
                                    progress: phKeys["w-" + item.workout_id]?.watchedtime || null
                                };

                                return (
                                    <>
                                        <SwiperSlide key={"t2-" + index}>
                                            <Card isFavorite={favorite} video={vid} withDate={withDate} />
                                        </SwiperSlide>
                                    </>
                                )
                            })
                            : <>
                                <SwiperSlide key="skl-1">  <CardSkeleton /> </SwiperSlide>
                                <SwiperSlide key="skl-2">  <CardSkeleton /> </SwiperSlide>
                                <SwiperSlide key="skl-3">  <CardSkeleton /> </SwiperSlide>
                                <SwiperSlide key="skl-4">  <CardSkeleton /> </SwiperSlide>
                            </>
                    }
                </Swiper>
            }

            {
                orientation == "y" &&
                <div className='row y-orientation-wrapper'>
                    {
                        filtered?.length > 0
                            ? filtered && filtered?.map((item, index) => {

                                let vid = {
                                    ...item,
                                    progress: phKeys["w-" + item.workout_id]?.watchedtime || null
                                };

                                return (
                                    <div key={"yo-tc5-" + index} className={`col-md-${screenSize == "xl" ? 6 : 6}`}>
                                        <Card isViewdWorkout={item.workout_id == viewedWorkout} isFavorite={favorite} video={vid} withDate={withDate} />
                                    </div>
                                )

                            })
                            : <CardSkeleton />
                    }
                </div>
            }

        </div >
    );
};

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {

})(ThumbnailWorkoutList);